/* WOLF BROS – Cart & Checkout FX (v1) */
(function () {
  if (window.__wolfCartFx) return;
  window.__wolfCartFx = true;

  var ICON = {
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="1.5"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>',
    arrow: '<svg class="wf-btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6l8-3z"/><path d="M9 12l2 2 4-4"/></svg>',
    card: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="1.5"/><path d="M3 10h18"/></svg>'
  };

  function decorateButton(btn) {
    if (!btn || btn.dataset.wfDone) return;
    btn.dataset.wfDone = '1';
    var text = btn.textContent.trim();
    btn.innerHTML =
      '<span class="wf-btn-shine" aria-hidden="true"></span>' +
      '<span class="wf-btn-label">' + ICON.lock + '<span>' + text + '</span>' + ICON.arrow + '</span>';
  }

  function decorateAllButtons() {
    document
      .querySelectorAll('.cart__checkout-button, #cart-notification-form .button[name="checkout"]')
      .forEach(decorateButton);
  }

  function addSteps() {
    var wrap = document.querySelector('cart-items .title-wrapper-with-link');
    if (!wrap || document.querySelector('.wf-steps')) return;
    var ol = document.createElement('ol');
    ol.className = 'wf-steps';
    ol.setAttribute('aria-label', 'Checkout steps');
    ol.innerHTML =
      '<li class="is-active"><span class="wf-dot">1</span>Cart</li>' +
      '<li aria-hidden="true" class="wf-sep"></li>' +
      '<li><span class="wf-dot">2</span>Details</li>' +
      '<li aria-hidden="true" class="wf-sep"></li>' +
      '<li><span class="wf-dot">3</span>Payment</li>';
    wrap.insertAdjacentElement('afterend', ol);
  }

  function addTrust() {
    var ctas = document.querySelector('#main-cart-footer .cart__ctas');
    if (!ctas || document.querySelector('.wf-trust')) return;
    var d = document.createElement('div');
    d.className = 'wf-trust';
    d.innerHTML =
      '<span>' + ICON.shield + 'Secure checkout</span>' +
      '<span>' + ICON.card + 'Encrypted payment</span>';
    ctas.insertAdjacentElement('afterend', d);
  }

  function indexItems() {
    document.querySelectorAll('cart-items .cart-item').forEach(function (row, i) {
      row.style.setProperty('--wf-i', i);
    });
  }

  function bump(el) {
    if (!el) return;
    el.classList.remove('wf-bump');
    void el.offsetWidth;
    el.classList.add('wf-bump');
  }

  function watchCart() {
    var cartItems = document.querySelector('cart-items');
    if (!cartItems) return;
    indexItems();
    setTimeout(function () { cartItems.classList.add('wf-settled'); }, 1600);

    document.addEventListener('click', function (e) {
      var rm = e.target.closest && e.target.closest('cart-remove-button');
      if (rm) {
        var row = rm.closest('.cart-item');
        if (row) row.classList.add('wf-removing');
      }
    }, true);

    var footer = document.getElementById('main-cart-footer');
    var tv = footer && footer.querySelector('.totals__total-value');
    var lastTotal = tv ? tv.textContent.trim() : '';

    var mo = new MutationObserver(function () {
      indexItems();
      decorateAllButtons();
      addTrust();
      var t = footer && footer.querySelector('.totals__total-value');
      if (t && t.textContent.trim() !== lastTotal) {
        lastTotal = t.textContent.trim();
        bump(t);
        document.querySelectorAll('cart-items .cart-item__price-wrapper .price').forEach(bump);
      }
    });
    mo.observe(document.querySelector('#main-cart-items') || cartItems, { childList: true, subtree: true });
    if (footer) mo.observe(footer, { childList: true, subtree: true });
  }

  var overlay;
  function buildOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'wf-go';
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');
    overlay.innerHTML =
      '<div class="wf-go__inner">' +
      '<div class="wf-go__ring" aria-hidden="true"></div>' +
      '<p class="wf-go__brand">Wolf <b>Bros</b></p>' +
      '<div class="wf-go__sub">' + ICON.lock + 'Securing your checkout</div>' +
      '<div class="wf-go__track" aria-hidden="true"><div class="wf-go__bar"></div></div>' +
      '</div>';
    document.body.appendChild(overlay);
    return overlay;
  }

  var hideTimer;
  function showOverlay() {
    var o = buildOverlay();
    void o.offsetWidth;
    o.classList.add('is-on');
    document.documentElement.classList.add('wf-lock');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideOverlay, 9000);
  }
  function hideOverlay() {
    if (!overlay) return;
    overlay.classList.remove('is-on');
    document.documentElement.classList.remove('wf-lock');
  }

  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (!(s && s.name === 'checkout')) return;
    setTimeout(function () { if (!e.defaultPrevented) showOverlay(); }, 0);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="/checkout"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    setTimeout(function () { if (!e.defaultPrevented) showOverlay(); }, 0);
  });
  window.addEventListener('pageshow', hideOverlay);

  function watchNotification() {
    var n = document.getElementById('cart-notification');
    if (!n) return;
    new MutationObserver(decorateAllButtons).observe(n, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    decorateAllButtons();
    addSteps();
    addTrust();
    watchCart();
    watchNotification();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
